/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Rtl_LabelInputs */

const en_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right-To-Left`)
};

const fr_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite a gauche`)
};

const de_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von rechts nach links`)
};

const it_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da destra a sinistra`)
};

const ru_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справа налево`)
};

const es_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De derecha a izquierda`)
};

const zh_cn2_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右到左`)
};

const ja_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右から左へ`)
};

const hi_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाएँ से बाएँ`)
};

const pt_pt2_merge_event_group_rtl_label = /** @type {(inputs: Merge_Event_Group_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da direita para a esquerda`)
};

/**
* | output |
* | --- |
* | "Right-To-Left" |
*
* @param {Merge_Event_Group_Rtl_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_rtl_label = /** @type {((inputs?: Merge_Event_Group_Rtl_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Rtl_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_rtl_label(inputs)
	if (locale === "de") return de_merge_event_group_rtl_label(inputs)
	if (locale === "it") return it_merge_event_group_rtl_label(inputs)
	if (locale === "ru") return ru_merge_event_group_rtl_label(inputs)
	if (locale === "es") return es_merge_event_group_rtl_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_rtl_label(inputs)
	if (locale === "ja") return ja_merge_event_group_rtl_label(inputs)
	if (locale === "hi") return hi_merge_event_group_rtl_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_rtl_label(inputs)
	return en_merge_event_group_rtl_label(inputs)
});